import { useState, useCallback } from "react";
import { usePermissions } from "./usePermissions";

interface UseEditRestrictionReturn {
  isRestrictionModalOpen: boolean;
  handleEditAttempt: () => boolean; // Retorna true si puede editar, false si está restringido
  closeRestrictionModal: () => void;
  restrictionMessage?: string;
}

export const useEditRestriction = (): UseEditRestrictionReturn => {
  const [isRestrictionModalOpen, setIsRestrictionModalOpen] = useState(false);
  const permissions = usePermissions();

  const handleEditAttempt = useCallback(() => {
    if (!permissions.canEditReservations && permissions.isRestrictedUser) {
      // Usuario restringido - mostrar modal
      setIsRestrictionModalOpen(true);
      return false; // No puede editar
    }

    if (!permissions.canEditReservations) {
      // Usuario sin permisos pero no restringido específicamente
      setIsRestrictionModalOpen(true);
      return false; // No puede editar
    }

    return true; // Puede editar
  }, [permissions.canEditReservations, permissions.isRestrictedUser]);

  const closeRestrictionModal = useCallback(() => {
    setIsRestrictionModalOpen(false);
  }, []);

  return {
    isRestrictionModalOpen,
    handleEditAttempt,
    closeRestrictionModal,
    restrictionMessage: permissions.restrictionMessage,
  };
};

export default useEditRestriction;
